import abi from './Transaction.json'
export const contractABI = abi.abi;
export const contractAddress = '0x6BC11815f8739De405e70Fab4144b996F015eE5c'